import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { useConfig } from '../../../context';
import { getLocale } from '../../../utils';
import Money, { Props as MoneyProps } from '../../../Money';
import { isZeroPrice as getIsZeroPrice } from '@shared/lib/money';

interface Props extends MoneyProps {
	className?: string;
	priceFromClassName?: string;
	priceFromAfterClassName?: string;
	priceFrom?: boolean;
}

const SeatPrice: React.FC<Props> = ({
	className,
	priceFromClassName,
	moneyClassName,
	amountClassName,
	currencyClassName,
	priceFromAfterClassName,
	priceFrom,
	...props
}) => {
	const { t } = useTranslation('SeatMap');
	const { SeatPrice: theme } = useTheme('SeatMap');

	const {
		global: {
			companyInfo: { iataCode }
		}
	} = useConfig();

	const locale = getLocale();

	const showFromAfterMoney = ['A9', 'RM', 'DV'].includes(iataCode) && ['ka', 'hy', 'kk'].includes(locale);
	const isZeroPrice = getIsZeroPrice(props.money);

	const money = (
		<>
			{priceFrom && !showFromAfterMoney && <span className={priceFromClassName}>{t('from')}</span>}
			<Money
				moneyClassName={cn(moneyClassName, theme.money)}
				amountClassName={cn(amountClassName, theme.amount)}
				currencyClassName={cn(currencyClassName, theme.currency)}
				{...props}
			/>
			{priceFrom && showFromAfterMoney && (
				<span className={cn(priceFromClassName, priceFromAfterClassName)}>{t('from')}</span>
			)}
		</>
	);

	if (!isZeroPrice) {
		return <span className={className}>{money}</span>;
	}

	return (
		<span className={cn(theme.root, theme.root_zeroPrice, className)}>
			{isZeroPrice && <span className={theme.root__text}>{t('Free seat')}</span>}
			<span className={theme.root__money}>{money}</span>
		</span>
	);
};

export default SeatPrice;
